module.exports = __webpack_public_path__ + "static/media/997659.fc1778b1.jpg";